var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Item"},[_c('headerItem',{attrs:{"msg":"2024年月贷款概况","bgColor":"","titleBeforeColor":"","rightIcon":""}}),_c('div',{staticClass:"grid-container"},[_c('div',{ref:"chart",staticClass:"flex-1 charts-style",staticStyle:{"width":"100%","min-height":"320px"},attrs:{"id":"chart"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }